import * as React from 'react';

import Divider from 'components/Divider';

import './MenuDivider.scss';

export default function MenuDivider() {
  return <Divider element="li" size="xxsmall" className="MenuDivider" />;
}
